import { ScrollToPlugin } from 'gsap/ScrollToPlugin.js';
import { gsap, ScrollTrigger, gsapScrollTo, initChoicesJs } from '../layout';

gsap.registerPlugin(ScrollToPlugin)


function scrollDownAfterFilter() {

    const urlQuery = window.location.search.slice(1) // GET QUERY URL

    if (urlQuery) {
        setTimeout(() => {
            gsapScrollTo('.intro', true, 'top top')
        }, 500);
    }
}

function filterBusiness() {
    let filterForm = document.querySelector('#filter-business-form-js');
    let filterSelect = document.querySelector('#filter-business-select-js');
    if(filterSelect) {
        filterSelect.addEventListener("change", () => {
            filterForm.submit();
        });
    }
}

function setMarginMinus() {
    // get space between element and window
    const elementTarget = document.querySelector('.detail__image-container')
    if (elementTarget) {
        const containerSize = document.querySelector('.detail .container').offsetWidth
        const windowSize = window.innerWidth
        const containerSpacing = (windowSize - containerSize) / 2 + 10
    
        if (window.innerWidth >= 992) {
            elementTarget.style.marginLeft = '-' + containerSpacing + 'px'
        }
    }
}

function snapToBelowSection() {
    const detailEl = document.querySelector('.detail')

    if (detailEl) {

        ScrollTrigger.create({
            trigger: '.detail',
            start: 'top+=15px bottom',
            end: 'top-=15px top',
            onEnter: () => {
                // console.log('start')
                //     gsap.to(window, {
                //         duration: .3,
                //         scrollTo: elPos
                //     })
                window.onscroll = () => {
                    // console.log('start')
                    if (ScrollTrigger.isTouch !== 1) {
                        const elPos = document.querySelector('.detail').offsetTop
                        window.scrollTo({
                            top: elPos,
                            left: 0,
                        });
                    }
                }
            },
            onLeave: () => {
                window.onscroll = () => {
                    // console.log('end')
                }
            },
            toggleActions: 'play none none restart',
        })
    }
}

window.addEventListener('DOMContentLoaded', () => {
    scrollDownAfterFilter()
    initChoicesJs()
    filterBusiness()
    setMarginMinus()
    snapToBelowSection()
})